import { IController, IWindowService } from 'angular';
import { IState, IStateOptions, IStateService } from 'angular-ui-router';
import { extend } from 'lodash';
import { ISchool } from '../../../ng2/shared/typings/interfaces/school.interface';
import { IStudentSupport } from '../../../ng2/shared/typings/interfaces/student-support.interface';
import { ISchoolSupport } from '../../../ng2/shared/typings/interfaces/support.interface';
import { IUser } from '../../../ng2/shared/typings/interfaces/user.interface';
import { SpinnerModal } from '../../shared/modals/status-spinner/status-spinner.service';
import { SupportAttendanceService } from '../../shared/services/support-attendance/support-attendance.service';
export class SupportOverviewCtrl implements IController {
  static $inject: string[] = [
    '$state',
    '$window',
    'attendanceRecords',
    'currentSchool',
    'currentUser',
    'SpinnerModal',
    'studentSupports',
    'support',
    'SupportAttendanceService',
  ];

  public schoolSupports: ISchoolSupport[];
  public activeSupportsForCurrentUser: ISchoolSupport[];
  public showByDate: boolean;

  constructor(
    private $state: IStateService,
    private $window: IWindowService,
    private attendanceRecords,
    private currentSchool: ISchool,
    private currentUser: IUser,
    private SpinnerModal: SpinnerModal,
    private studentSupports: IStudentSupport[],
    private support,
    private SupportAttendanceService: SupportAttendanceService,
  ) {}

  $onInit() {
    this.showByDate = true;
    this.SpinnerModal.deactivateSpinner();
  }

  onTakeAttendanceClick(supportId) {
    this.SpinnerModal.activateSpinner(`Loading attendance data...`);
    this.$state.go('main.school.support-attendance-form', { supportId });
  }

  // TODO: This should be moved to a resolve block. I think it's calculated more than once?
  getMissingLogsCount(support, attendanceRecords, studentSupports) {
    const missingLogDates = this.SupportAttendanceService.getMissingAttendanceDates(
      support,
      attendanceRecords,
      studentSupports,
      true,
    );
    return missingLogDates.filter(obj => obj.isUnlogged === true).length;
  }

  toggleView = () => (this.showByDate = !this.showByDate);

  disableLogging() {
    // Has not started
    if (this.support.isNotStarted()) return true;
    // Is completed and all logs submitted
    if (this.support.isCompleted()) return true;
    // No unlogged dates
    const countOfMissingLogs = this.getMissingLogsCount(this.support, this.attendanceRecords, this.studentSupports);
    if (countOfMissingLogs === 0) return true;
    // No students assigned
    if (this.studentSupports.length === 0) return true;
    return false;
  }

  // TODO: DUP OF method found on v3 sidenav - candidate for component - JYR
  goState(state: IState, params: IStateOptions): void {
    if (state === this.$state.current.name) {
      return;
    } else {
      this.SpinnerModal.activateSpinner('Loading...');
      this.$state.go(state, extend(this.$state.params, params));
    }
  }
}
